import { TRichText } from '../../../types/utils/richText';

export const getValidText = (text: TRichText): TRichText | null =>
  text?.content?.some(({ content }) => content?.some(({ text }) => text?.replace(/\s/g, '')))
    ? text
    : null;
